import Modal from 'flarum/common/components/Modal';

/**
 * 公众号二维码弹窗。
 * 公众号网页授权在 PC 浏览器里用不了（微信会直接报错），
 * 所以在非微信环境下改成展示公众号二维码，引导用户扫码后在微信内打开。
 */
export default class WechatQrcodeModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.qrcode = this.attrs.qrcode || '';
    this.name = this.attrs.name || '我们的公众号';
  }

  className() {
    return 'WechatQrcodeModal Modal--small';
  }

  title() {
    return '关注公众号';
  }

  content() {
    return (
      <div className="Modal-body WechatQrcodeModal-body">
        <p className="helpText">
          当前模式为「微信公众号登录」，需要在微信内置浏览器中打开论坛才能授权。
        </p>
        <p className="helpText">
          请扫码关注 <strong>{this.name}</strong>，再从公众号菜单进入论坛。
        </p>

        {this.qrcode ? (
          <div className="WechatQrcodeModal-image">
            <img src={this.qrcode} alt={this.name + ' 二维码'} />
          </div>
        ) : (
          <p className="helpText">后台未配置公众号二维码图片地址。</p>
        )}
      </div>
    );
  }
}
